"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = require("./constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var env = function () {
    var getApiRoot = function getApiRoot() {
        var apiRoot;
        var location = window.location.hostname.toLowerCase();

        if (_isProd(location)) apiRoot = "https://bigfoot.jugglestreet.com";else if (_isStaging(location)) apiRoot = "https://sbigfoot.jugglestreet.com";else if (_isLocal(location)) apiRoot = "https://dbigfoot.jugglestreet.com";else if (_isDev(location)) apiRoot = "http://localhost:7171";

        return apiRoot;
    };

    var getApiUrl = function getApiUrl(path) {
        var apiRoot = getApiRoot(path);

        return apiRoot + "/api/" + path;
    };

    var getLoginAsBaseUrl = function getLoginAsBaseUrl(targetDevice, country) {
        var rootUrl = void 0;
        var location = window.location.hostname.toLowerCase();

        if (targetDevice == _constants2.default.deviceType.DESKTOP) {

            if (_isProd(location)) rootUrl = country === "au" ? "https://web.jugglestreet.com.au/" : "https://web.jugglestreet.co.nz/";else if (_isStaging(location)) rootUrl = "https://sw.jugglestreet.com/";else if (_isLocal(location)) rootUrl = "//localhost:3000/";else if (_isDev(location)) rootUrl = "//frontendserver:3000/";
        } else {
            if (_isProd(location)) rootUrl = country === "au" ? "https://m.jugglestreet.com.au/" : "https://m.jugglestreet.co.nz/";else if (_isStaging(location)) rootUrl = "https://sm.jugglestreet.com/";else if (_isLocal(location)) rootUrl = "//localhost:8080/";else if (_isDev(location)) rootUrl = "//frontendserver:8080/";
        }

        return rootUrl;
    };

    var getStorageUrl = function getStorageUrl(path) {
        var storageUrl;
        var location = window.location.hostname.toLowerCase();

        if (_isProd(location)) storageUrl = "https://jsprodaue.blob.core.windows.net/";else if (_isStaging(location)) storageUrl = "https://jsstagingaue.blob.core.windows.net/";else if (_isLocal(location)) storageUrl = "https://jsdevaue.blob.core.windows.net/";else if (_isDev(location)) storageUrl = "https://jsdevlocalaue.blob.core.windows.net/";

        return storageUrl;
    };

    var isAdmin = function isAdmin() {
        var location = window.location.hostname.toLowerCase();
        return location.startsWith("admin") || location.startsWith("sadmin");
    };

    var isAnalytics = function isAnalytics() {
        var location = window.location.hostname.toLowerCase();
        return location.startsWith("analytics") || location.startsWith("sanalytics");
    };

    var defaultState = function defaultState() {
        var defaultState = void 0;
        if (env.isAdmin()) {
            defaultState = "users";
        } else if (env.isAnalytics()) {
            defaultState = "analyticsUsers";
        } else {
            throw new Error("Unsupported subdomain");
        }

        return defaultState;
    };

    var pageTitle = function pageTitle() {
        var pageTitle = void 0;
        if (env.isAdmin()) {
            pageTitle = "Juggle Street Admin Portal";
        } else if (env.isAnalytics()) {
            pageTitle = "Juggle Street Analytics Portal";
        } else {
            throw new Error("Unsupported subdomain");
        }

        return pageTitle;
    };

    var _isLocal = function _isLocal(location) {
        return location.startsWith("localhost");
    };

    var _isDev = function _isDev(location) {
        return location.indexOf("frontendserver") != -1 || location.indexOf("local") != -1;
    };

    var _isProd = function _isProd(location) {
        return location.startsWith("admin.jugglestreet.com") || location.startsWith("analytics.jugglestreet.com");
    };

    var _isStaging = function _isStaging(location) {
        return location.startsWith("sadmin.jugglestreet.com") || location.startsWith("sanalytics.jugglestreet.com");
    };

    return { getApiRoot: getApiRoot, getApiUrl: getApiUrl, getLoginAsBaseUrl: getLoginAsBaseUrl, getStorageUrl: getStorageUrl, isAdmin: isAdmin, isAnalytics: isAnalytics, defaultState: defaultState, pageTitle: pageTitle };
}();

exports.default = env;


/** WEBPACK FOOTER **
 ** ./client/app/utils/env.js
 **/